module.exports = __webpack_public_path__ + "media/npc_dota_hero_tusk.53268703.webm";